/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private router: Router) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    console.log(this.router)

    return next.handle(req)
      .pipe(catchError((error: HttpErrorResponse) => {



        if (error.status === 401) {

          if (this.router.url == '/'){
            this.router.navigate(['onboarding']);
          }
          else {
            this.router.navigate(['auth/login']);
          }
 
        }
        // TODO: handle 403 error ?
        return throwError(error);
      }));
  }
}
